import React, { Component, Fragment } from 'react'
import Button from '../../../components/atoms/Button'
import TextBox from '../../../components/atoms/TextBox'
import DatePicker from '../../../components/atoms/DatePicker'
import SelectFiles from '../../../components/atoms/SelectFiles'
import LabelWithInput from '../../../components/molecules/LabelWithInput';
import { addDays } from 'date-fns';
import InformationText from '../../../components/molecules/InformationText'
import Loading from '../../../components/molecules/Loading'
import { URL_API_FILE_COLATERAL } from '../../../config/api';
import UploadOneImages from '../../../utils/actions/UploadOneImages'
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo'
import curencyFormat from '../../../utils/helpers/curencyFormat'

export class DataJaminan extends Component {
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
            nama : '',
            no_invois : '',
            tgl_invois : '',
            tgl_tempo : '',
            nilai_invois : '',
            invois : {
                error : null,
                loading : false,
                link : ''
            },
            load_back : false,
            load_next : false
        }
    }

    onChangeHandler = ({value, name}) => {
        if(name === 'nilai_invois'){
            value = value.replace(/\D/g,"")
        }
        console.log({ value, name });

        if (this._isMounted) {
            this.setState({
                [name] : value
            })
        }
    }

    setStateList = (parent, child, value) => {
        if (this._isMounted) {
            this.setState({
                [parent] : {
                    ...this.state[parent],
                    [child] : value
                }
            })
        }
    }

    uploadInvois = (name, value) => {
        const {ClientID} = this.props;
        const {loanCode} = this.props.match.params;
        
        this.setStateList(name, 'loading', true);
        if(ClientID){
            UploadOneImages(URL_API_FILE_COLATERAL(loanCode), {name : 'file', file : value}, ClientID, (hasil, error) => {
                this.setStateList(name, 'loading', false);
                if(!error){
                    this.setStateList(name, 'link', hasil.document.collateral.url);
                }else{
                    this.setStateList(name, 'error', error);
                }
            });
        }
    }

    onSubmitBack = (step) => {
        const {nama, no_invois, tgl_invois, tgl_tempo, nilai_invois, invois} = this.state;
        const {loanCode} = this.props.match.params;
        const {SetError, postOrPatch} = this.props;
        console.log("ini submit === ", nilai_invois);
        
        if (this._isMounted) {
            this.setState({
                load_back : (step == 0) ? true : false,
                load_next : (step == 2) ? true : false
            })
        }
        let collateralDetail = {}
        if(nama){
            collateralDetail.payorName = nama
        }
        if(no_invois){
            collateralDetail.invoiceNumber = no_invois
        }
        if(tgl_invois){
            collateralDetail.invoiceIssueDate = tgl_invois && dateFormatIndo(tgl_invois, 'db')
        }
        if(tgl_tempo){
            collateralDetail.invoiceDueDate = tgl_tempo && dateFormatIndo(tgl_tempo, 'db')
        }
        if(nilai_invois){
            collateralDetail.invoiceAmount = `${nilai_invois}`
        }
        postOrPatch({
            data : {collateralDetail},
            stepChange : step,
            loanCode
        })
    }
    onSubmitStep = (step) => {
        const {nama, no_invois, tgl_invois, tgl_tempo, nilai_invois, invois} = this.state;
        const {loanCode} = this.props.match.params;
        const {SetError, postOrPatch} = this.props;
        console.log("ini submit === ", nilai_invois);
        
        if (this._isMounted) {
            this.setState({
                load_back : (step == 0) ? true : false,
                load_next : (step == 2) ? true : false
            })
        }

        (nama == '' || no_invois == '' || tgl_invois == '' || tgl_tempo == '' || nilai_invois  == '' || invois.link == '') ? SetError('Semua field di tahap ini harus diisi sebelum Anda pindah ke tahap selanjutnya.') :
        postOrPatch({
            data : {
                collateralDetail : {
                    payorName : nama,
                    invoiceNumber : no_invois,
                    invoiceIssueDate : tgl_invois && dateFormatIndo(tgl_invois, 'db'),
                    invoiceDueDate : tgl_tempo && dateFormatIndo(tgl_tempo, 'db'),
                    invoiceAmount : `${nilai_invois}`
                }
            },
            stepChange : step,
            loanCode
        })
    }


    componentDidMount = () => {
        this._isMounted = true;
        this.props.ResetStatusState();
    }

    componentDidUpdate = (prevProps) => {
        if(this.props.detailPinjaman.detail !== prevProps.detailPinjaman.detail){
            if(this.props.detailPinjaman.detail !== null){
                const {detail} = this.props.detailPinjaman;
                const {payorName, invoiceNumber, invoiceIssueDate, invoiceDueDate, invoiceAmount} = detail.collateralDetail;
                const {collateralDocuments} = detail.infoColateral;

                if (this._isMounted) {
                    console.log({invoiceAmount}, Number(invoiceAmount));
                    
                    this.setState({
                        nama : payorName ? payorName : '',
                        no_invois : invoiceNumber ? invoiceNumber : '',
                        tgl_invois : invoiceIssueDate ? new Date(invoiceIssueDate) : '',
                        tgl_tempo : invoiceDueDate ? new Date(invoiceDueDate) : '',
                        nilai_invois : invoiceAmount ? (invoiceAmount > 0 ? Number(invoiceAmount) : '' ) : '' ,
                        invois : {
                            ...this.state.invois,
                            link : (collateralDocuments.length > 0) ? collateralDocuments[0].url : ''
                        }
                    })
                }
            }
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    render() {
        const {detailPinjaman, col, status} = this.props;
        const {nama, no_invois, tgl_invois, tgl_tempo, nilai_invois, invois, load_back, load_next} = this.state;

        return (
            detailPinjaman.loading ? <Loading /> :(
                <Fragment>
                    <LabelWithInput label='Nama Pembayar' col={col} {...this.props}>
                        <TextBox onChange={e => {this.onChangeHandler(e.target)}} value={nama} name='nama' /> 
                    </LabelWithInput>

                    <LabelWithInput label='No. Invois' col={col} {...this.props}>
                        <TextBox onChange={e => {this.onChangeHandler(e.target)}} value={no_invois} name='no_invois' /> 
                    </LabelWithInput>

                    <LabelWithInput label='Tgl. Invois' col={col} {...this.props}>
                        <DatePicker onChange={e => {this.onChangeHandler(e)}} value={tgl_invois} name='tgl_invois' /> 
                    </LabelWithInput>

                    <LabelWithInput required label='Tgl. Jatuh Tempo Invois' col={col} {...this.props} info='Tgl. Jatuh Tempo Invois minimal 15 hari dari hari ini'>
                        <DatePicker onChange={e => {this.onChangeHandler(e)}} value={tgl_tempo} name='tgl_tempo' min={addDays(new Date(), 15)} /> 
                    </LabelWithInput>

                    <LabelWithInput label='Nilai Invois' col={col} {...this.props} info='Nilai pinjaman awal akan diset 80% dari nilai ini'>
                        <TextBox onChange={e => {this.onChangeHandler(e.target)}} value={nilai_invois ? curencyFormat(nilai_invois) : ''}  name='nilai_invois' /> 
                    </LabelWithInput>

                    <LabelWithInput label='Unggah Invois' col={col} {...this.props} info='File berukuran maksimal 3MB dan berformat PDF, JPG , JPEG, PNG' note = {invois.error}>
                        <SelectFiles name='invois' extention='.pdf,.png,.jpg,.jpeg'  onChange={(name, value) => {this.uploadInvois(name, value)}} loading={invois.loading} files={invois.link} />
                    </LabelWithInput>

                    <div className='bg-button'>
                        <Button title='Kembali' color='outline' width='big' loading={status.loading && load_back} onClick={() => this.onSubmitBack(0)} />
                        <Button title='Selanjutnya' color='blue' width='big' loading={status.loading && load_next} onClick={() => this.onSubmitStep(2)} />
                    </div>

                    {/* { (status.error) && <InformationText value={status.error} type='error' className='mt-3' /> } */}
                </Fragment>
            ) 
        )
    }
}

export default DataJaminan;
